import React, { useContext, useMemo } from "react";
import flatten from "lodash/flatten";
import ListStateContext from "logview/components/contexts/ListStateContext";
import useLogViewLayout from "logview/hooks/useLogViewLayout";
import SelectableMessageTableMessagesContext from "views/components/widgets/SelectableMessageTableMessagesContext";
const defaultIsEntitySelectable = () => true;
const SelectableLogViewMessagesProvider = ({
  children = null,
  isEntitySelectable = defaultIsEntitySelectable,
  displayBulkSelectCol = false
}) => {
  const { allLoadedPages } = useContext(ListStateContext);
  const { timestampField } = useLogViewLayout();
  const contextValues = useMemo(() => {
    if (!displayBulkSelectCol) return { selectableMessageTableMessages: [] };
    return {
      selectableMessageTableMessages: flatten(Object.values(allLoadedPages)).filter(isEntitySelectable).map(({ frontendId, message, index }) => ({
        id: frontendId,
        timestamp: message[timestampField],
        index
      }))
    };
  }, [allLoadedPages, displayBulkSelectCol, isEntitySelectable, timestampField]);
  return /* @__PURE__ */ React.createElement(SelectableMessageTableMessagesContext.Provider, { value: contextValues }, children);
};
export default SelectableLogViewMessagesProvider;
